import styled from 'styled-components'

export default styled.div`
  color: #80949F;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/WidgetPickerRow/SubHeader.js